"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimerIcon = function TimerIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '24',
    height: height || '24',
    viewBox: viewBox || '0 0 24 24',
    fill: fill,
    className: className,
    path: "M12.2102 1.06976C8.29059 0.588962 4.45511 2.45987 2.42114 5.84477C0.387173 9.22968 0.535697 13.4946 2.80021 16.7298C2.87674 16.839 2.99375 16.9131 3.1252 16.9356C3.25665 16.9582 3.39166 16.9273 3.50021 16.8498C3.7228 16.6872 3.77594 16.3772 3.62021 16.1498C1.18772 12.6676 1.52103 7.95874 4.41976 4.85391C7.31849 1.74908 11.9934 1.09363 15.6342 3.28159C19.275 5.46955 20.8904 9.90516 19.5093 13.922C18.1282 17.9389 14.1267 20.4433 9.91021 19.9298C9.63509 19.9002 9.38661 20.0955 9.35021 20.3698C9.32598 20.6433 9.51867 20.8886 9.79021 20.9298C15.2744 21.598 20.2619 17.6939 20.9302 12.2098C21.5985 6.72557 17.6944 1.73803 12.2102 1.06976ZM10.5002 3.99976C10.2241 3.99976 10.0002 4.22362 10.0002 4.49976V11.4998C10.0002 11.7759 10.2241 11.9998 10.5002 11.9998H15.5002C15.7764 11.9998 16.0002 11.7759 16.0002 11.4998C16.0002 11.2236 15.7764 10.9998 15.5002 10.9998H11.0002V4.49976C11.0002 4.22362 10.7763 3.99976 10.5002 3.99976ZM4.50021 15.9998H8.50021C8.77635 15.9998 9.00021 16.2236 9.00021 16.4998V20.4998C9.00021 20.7759 8.77635 20.9998 8.50021 20.9998H4.50021C4.22406 20.9998 4.00021 20.7759 4.00021 20.4998V16.4998C4.00021 16.2236 4.22406 15.9998 4.50021 15.9998ZM5.00021 19.9998H8.00021V16.9998H5.00021V19.9998Z"
  });
};

var _default = TimerIcon;
exports.default = _default;